import AdminPageComponent from '../component/AdminPageComponent';
import AdminPageList from '../component/AdminPageList';
import AdminPageDropDown from '../component/AdminPageDropDown';
const values = [
  {
    heading: 'Anamneza',
    text: 'Patient reports chest pain for three days, worsened with activity. History of hypertension for five years and diabetes for three years. Currently taking Metformin and Amlodipine. Family history includes stroke and hypertension in the father and diabetes in the mother. Smokes ten cigarettes daily, follows a poor diet, and has a sedentary lifestyle.',
  },
  {
    heading: 'Klinični status',
    text: 'Blood pressure is 145/90 mmHg, heart rate 88 bpm, oxygen saturation 96%, temperature 37.2°C, and respiratory rate 18 breaths per minute. Physical examination reveals no abnormal lung or heart sounds, and no signs of edema.',
  },
  {
    heading: 'Plan',
    text: 'Prescribed Aspirin and Atorvastatin with a possible beta-blocker. Ordered ECG, cardiac enzymes, and a stress test within 48 hours. Recommended smoking cessation, dietary improvements, and 30 minutes of daily exercise. Follow-up in one week, with a cardiology referral if symptoms persist.',
  },
];

export default function AdminPage() {
  return (
    <div className="flex flex-col sm:p-4 p-2 gap-4">
      <AdminPageComponent heading={values[0].heading} text={values[0].text} />
      <AdminPageComponent heading={values[1].heading} text={values[1].text} />
      <AdminPageList
        heading="Diagnoza"
        listitem="ICD-10 Code: I20.0 – Unstable Angina"
      />
      <AdminPageComponent heading={values[2].heading} text={values[2].text} />
      <AdminPageDropDown heading="Service Codes" />
    </div>
  );
}
